import * as React from 'react';
import CardContainer from '../common/CardContainer';
import { Card, Button } from '@blueprintjs/core';
import Form from 'src/components/controls/forms/Form';
import FormTextbox from '../controls/forms/FormTextbox';
import { AnyObject } from 'final-form';
import actions from 'src/actions';
import { connect } from 'react-redux';

interface IFormPocDispatchProps {
    secondWindowNavigate: (path: string, search?: string) => void;
    pushForm: (form: AnyObject) => void;
}

class FormPocComponent extends React.Component<IFormPocDispatchProps> {
    sendChange = (values: AnyObject) => {
        this.props.pushForm(values);
    };

    onSecondWindowNavigate = () => {
        this.props.secondWindowNavigate('/formdoc');
    };

    public render() {
        return (
            <CardContainer>
                <Card elevation={1} className="lh-form-panel">
                    <Form
                        onSubmit={() => {
                            console.log('submit');
                        }}
                        onChange={this.sendChange}
                    >
                        <div className="second-window-button" onClick={this.onSecondWindowNavigate}>
                            <span className="fas fa-external-link-alt" style={{ marginRight: '.5em' }} />
                        </div>
                        <h3>Data Entry:</h3>
                        <FormTextbox label="Name" name="name" />
                        <FormTextbox label="City" name="city" />
                        <Button type="submit" text="Submit" />
                    </Form>
                </Card>
            </CardContainer>
        );
    }
}

const mapDispatchToProps: IFormPocDispatchProps = {
    secondWindowNavigate: (path: string, search?: string) => actions.layout.pushToSecondWindow(path, search),
    pushForm: (values: AnyObject) => actions.navigation.pushForm(values),
};

export default connect(undefined, mapDispatchToProps)(FormPocComponent);



// WEBPACK FOOTER //
// ./src/components/FormPoc/Form.tsx